export default class designSectionLeftMenu {
	constructor(nodes) {
		if (nodes) {
			this._init(nodes);
		}
	}

	_init(nodes) {
		this.setBorderOnScrollLeftMenu();
		this.SetFilterVisibility();

		for (var i = 0; i < nodes.length; i++) {
			let node = nodes[i];
			node.addEventListener('click', evt => {
				evt.preventDefault();

				node.parentElement.classList.toggle('opened');

				if (node.nextElementSibling) {
					node.nextElementSibling.classList.toggle('show');
				}
				this.setBorderOnScrollLeftMenu();
			});
		}
	}

	//if the area is scrollable - add a border top to "footer" in left menu
	setBorderOnScrollLeftMenu() {
		let scrollableMenu = document.querySelector('.menu-design-section');

		let footer = document.querySelector('.designsection-header__footer__wrap');
		if (scrollableMenu.scrollHeight > scrollableMenu.clientHeight) {
			footer.classList.add('designsection-header__footer--scrolled');
		} else {
			footer.classList.remove('designsection-header__footer--scrolled');
		}
	}

	SetFilterVisibility() {
		document.addEventListener('DOMContentLoaded', () => {
			let filterWrapper = document.querySelector(
				'.designsection-header__filter'
			);
			let filter = document.querySelector(
				'.designsection-header__filter__form'
			);
			let footer = document.querySelector(
				'.designsection-header__footer__wrap'
			);
			let attr = filter.getAttribute('data-showfilter');
			if (attr === 'True') {
				filter.classList.add('designsection-header__filter--show');
				footer.classList.add('designsection-header__footer--scrolled');
			} else {
				filterWrapper.classList.add(
					'designsection-header__filter--show-wrapper'
				);
			}
		});
	}
}
